<template>
  <!-- 话务管理-外呼任务 -->
  <basic-container>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :table-loading="loading"
      :data="tableData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="loadData"
      @on-load="loadData"
    >
      <template slot="menuLeft">
        <el-button
          v-if="permissionList.addBtn"
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="openDialog('add')"
        >
          新增
        </el-button>
      </template>
      <template slot-scope="{ row }" slot="menu">
        <el-button
          v-if="permissionList.viewBtn"
          type="text"
          size="small"
          @click="openDialog('view', row)"
        >
          查看
        </el-button>
        <el-button
          v-if="permissionList.closeBtn && (row.taskStatus == 1 || row.taskStatus == 2)"
          type="text"
          size="small"
          @click="doClose(row)"
        >
          关闭
        </el-button>
        <el-button
          v-if="permissionList.logBtn && row.taskStatus != 1"
          type="text"
          size="small"
          @click="openDialog('log', row)"
        >
          日志
        </el-button>
      </template>
    </avue-crud>
    <!-- 弹框 -->
    <el-dialog
      :title="dialogTitle"
      width="60%"
      :visible.sync="isDialogShow"
      :before-close="beforeCloseDialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <AddDialog
        v-if="isDialogShow && dialogType == 'add'"
        :rowData="rowData"
        :projectId="searchForm.projectId"
        @update="updateTableDataSuccess"
        @close="beforeCloseDialog"
      ></AddDialog>
      <ViewDialog
        v-if="isDialogShow && dialogType == 'view'"
        :rowData="rowData"
        :projectId="searchForm.projectId"
        @close="beforeCloseDialog"
      ></ViewDialog>
      <LogDialog
        v-if="isDialogShow && dialogType == 'log'"
        :rowData="rowData"
        :projectId="searchForm.projectId"
        @close="beforeCloseDialog"
      ></LogDialog>
    </el-dialog>
  </basic-container>
</template>

<script>
import { mapGetters } from 'vuex';
import AddDialog from './add-dialog';
import ViewDialog from './view-dialog';
import LogDialog from './log-dialog';
import { getProjectListApi } from '@/api/call-system/index';
import { getPageListApi, closeApi } from '@/api/call-system/call-manage/outbound-task';

export default {
  components: {
    AddDialog,
    ViewDialog,
    LogDialog,
  },
  data() {
    return {
      oldProjectId: '', // 旧项目id，重置搜索条件和新增时需要使用
      projectList: [], // 项目列表
      dialogType: '', // 弹框的类型
      dialogTitle: '', // 弹框显示的标题
      isDialogShow: false, // 弹框是否显示着
      needCloseConfirm: false, // 关闭弹框时是否需要确认弹框，该值是根据场景动态调整的
      searchForm: {}, // 搜索条件
      loading: false, // 是否正在加载表格数据
      tableData: [], // 表格数据
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格显示的配置项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        index: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        dialogClickModal: false,
        searchMenuSpan: 12,
        searchLabelWidth: 100,
        labelWidth: 100,
        menuWidth: 160,
        column: [
          {
            label: '项目名称',
            prop: 'projectId',
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
            type: 'select',
            hide: true,
            showColumn: false,
            display: false,
            // search: true,
            // searchClearable: false,
          },
          {
            label: '任务名称',
            prop: 'name',
            search: true,
            maxlength: 20,
            showWordLimit: true,
          },
          {
            label: '开始时间',
            prop: 'startDate',
          },
          {
            label: '结束时间',
            prop: 'endDate',
          },
          {
            label: '时间段',
            prop: 'timePeriod',
          },
          {
            label: '任务状态',
            prop: 'taskStatus',
            search: true,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=callcenter_task_status',
            props: { label: 'dictValue', value: 'dictKey' },
          },
          {
            label: '优先级',
            prop: 'taskLevel',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=callcenter_task_level',
            props: { label: 'dictValue', value: 'dictKey' },
            dataType: 'string',
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.callSystem_callManage_outboundTask_add, true),
        viewBtn: this.vaildData(this.permission.callSystem_callManage_outboundTask_view, true),
        closeBtn: this.vaildData(this.permission.callSystem_callManage_outboundTask_close, true),
        logBtn: this.vaildData(this.permission.callSystem_callManage_outboundTask_log, true),
      };
    },
  },
  created() {
    getProjectListApi().then(({ data }) => {
      this.projectList = data || [];
      if (this.projectList.length > 0) {
        this.findObject(this.tableOption.column, 'projectId').dicData = this.projectList;
        this.searchForm.projectId = this.projectList[0].id;
        this.loadData();
      }
    });
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 336; // 表格区域初始化高度
      const searchH = 57; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    /* 加载表格数据 */
    loadData(page) {
      if (!this.searchForm.projectId) return;
      this.oldProjectId = this.searchForm.projectId;
      page = page || this.tablePage;
      this.loading = true;
      getPageListApi(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchForm)
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.tableData = data.records;
        this.loading = false;
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.searchForm = {
        projectId: this.oldProjectId,
      };
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.searchForm = params;
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    /* 表格数据更新成功 */
    updateTableDataSuccess() {
      this.loadData();
      this.dialogType = '';
      this.isDialogShow = false;
    },
    /* 关闭 */
    doClose(row) {
      this.$confirm('确认关闭？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return closeApi({
            id: row.id,
          });
        })
        .then(() => {
          this.updateTableDataSuccess();
          this.$message.success('操作成功!');
        });
    },
    /* 打开弹框 */
    openDialog(type, rowData = {}) {
      let titles = {
        add: '新增',
        view: '查看',
        log: '日志',
      };
      this.dialogTitle = titles[type];
      this.dialogType = type;
      this.rowData = rowData;
      if (type == 'add') {
        this.needCloseConfirm = true;
      } else {
        this.needCloseConfirm = false;
      }
      this.isDialogShow = true;
    },
    /* 关闭表单弹框的确认框 */
    beforeCloseDialog(done) {
      if (!this.needCloseConfirm) {
        if (typeof done == 'function') {
          done();
        } else {
          this.dialogType = '';
          this.isDialogShow = false;
        }
      } else {
        this.$confirm(' 是否关闭继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (typeof done == 'function') {
              done();
            } else {
              this.dialogType = '';
              this.isDialogShow = false;
            }
          })
          .catch(() => {});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
